import { cn } from "@/lib/utils";
import { formatSizeDisplay } from "@/utils/formatSizeDisplay";

interface SizeDisplayProps {
    fileSizeBytes: number | null;
    pageCount: number | null;
    className?: string;
}

export function SizeDisplay({
    fileSizeBytes,
    pageCount,
    className,
}: SizeDisplayProps) {
    return (
        <span
            className={cn(
                "text-muted-foreground text-sm tabular-nums",
                className
            )}
        >
            {formatSizeDisplay(fileSizeBytes, pageCount)}
        </span>
    );
}
